export const locale = {
    lang: "es-ES",
    data: {
        TERMS_OF_USE: {
            TITLE: "Términos de Uso",
            DEFAULT: "Términos de uso no definidos.",
            SUBMIT_ERROR: "Error al recuperar los términos de uso.",
            BUTTON_LABEL: "Cerrar"
        }
    }
};
